export const API_KEYS_URL = 'ui/partner/api_keys';

export const apiKeysQueryKeys = {
  all: [API_KEYS_URL],
};
